import { Avatar, Box, Button, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { PLATFORMS_IMGS_LIST, trunCateString } from "../../utils/constant";
import createWishlistModalIcon from '../../assets/images/icons/createWishlistModalIcon.svg'
import { getFormetedDateWithMonth } from '../../utils/common';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  top: '0px',
  bottom: '0px',
  right: '0%',
  left: 'revert',
  border: '0px solid red',
  borderRadius: '16px', padding: '0px',
  backgroundRepeat: 'no-repeat',
  height: 'fit-content', width: 'fit-content',
  "& .MuiDialog-container": {
    margin: 0,
  },
  "& .MuiPaper-root": {
    margin: '0px !important',
    background: "white",
    border: '0px solid blue',
    borderRadius: '0px',
    maxWidth: '100dvw',
    maxheight: '100dvh',
    height: '100dvh',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: '600px',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '800px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '975px',
    },
    padding: '0px'
  },
  "& .MuiBackdrop-root": {
    border: '0px solid green',
    margin: '0px !important',
  },
  '& .MuiDialogContent-root': {
  },
  '& .MuiDialogActions-root': {
  },
}));
export default function WishlistListingModal(props) {
  const { open = true, setOpen = () => { }, setCreateWishlistModalOpen, setSearchParams } = props;
  const handleClose = () => setOpen(false);
  const { wishlistList } = useSelector(state => state.wishlistSlice);
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title ccc"
        open={open}
      >
        <Box sx={{
          padding: '20px 16px 0 16px',
          height: '12%'
        }}>
          <Stack direction={{ xs: 'column', sm: "row" }} justifyContent="space-between" alignItems={{ xs: '', sm: "center" }} gap={{ xs: 2, sm: 0 }} >
            <Box sx={{ padding: '0', position: 'relative', }}>
              <Typography sx={{ fontSize: { xs: '14px', sm: '18px', md: '22px', lg: '24px' }, fontWeight: 600, color: '#000' }}>
                Select list
              </Typography>
              <Typography sx={{ fontSize: { xs: '12px', md: '14px', lg: '16px' }, fontWeight: 600, color: '#AAA' }}>Select an existing list or create a new one</Typography>
            </Box>
          </Stack>
        </Box>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            overflow: 'scroll',
            height:'80%',paddingBottom:'20px',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}>
          <Stack direction="row" justifyContent={{ xs: 'center', sm: "flex-start" }} gap={{ xs: 3, sm: 3, md: 2, lg: 4 }} flexWrap={"wrap"} sx={{ paddingX: '16px' }}>
            <Stack onClick={() => {
              setOpen(false);
              setCreateWishlistModalOpen(true);
            }} direction="column" justifyContent="center" alignItems="center" gap={1.5} sx={{
              cursor: 'pointer',
              width: { xs: '350px', md: '293px' }, height: '156px', padding: 0, borderRadius: '6px', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', background: '#fff', border: `1px solid #CACACA`, borderLeft: '6px solid #CACACA'
            }}>
              <img src={createWishlistModalIcon} alt="createWishlistModalIcon" style={{ height: '24px', width: '24px' }} />
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C' }}>Create New List</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#9F9C9C' }}>Click to create new list</Typography>
            </Stack>
            {wishlistList?.map((item) => (
              <Stack onClick={() => { setOpen(false); setSearchParams({ wishlistId: item?.id }) }} key={item?.id} direction="column" gap={1.5} sx={{
                width: { xs: '350px', md: '293px' }, height: '156px', padding: '10px 16px', borderRadius: '6px', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', background: '#fff', border: `1px solid ${item?.color}`, borderLeft: `6px solid ${item?.color}`
              }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" >
                  <Box>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1.5}>
                      <Avatar src={item?.brandImage} sx={{
                        width: '40px', height: '40px'
                      }} />
                      <Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: '500', color: '#181D27' }}>{item?.influncersCount} Influencer</Typography>
                      </Box>
                    </Stack>
                  </Box>
                  <Box sx={{ gap: '5px', display: 'flex' }}>
                    <Button onClick={(v) => {
                      v.preventDefault();
                      v.stopPropagation();
                      setCreateWishlistModalOpen(true)
                    }} sx={{ height: '25px', width: '25px', padding: '0px', minWidth: 'fit-content' }}>
                    </Button>
                  </Box>
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Typography sx={{ color: '#181D27', fontWeight: '500', fontSize: '14px', textTransform: 'capitalize' }}>{trunCateString(item?.name, 15)}</Typography>
                    <Typography sx={{ color: '#535862', fontWeight: '400', fontSize: '14px', textTransform: 'capitalize' }}>{trunCateString(item?.brandName, 15)}</Typography>
                  </Box>
                  <img src={PLATFORMS_IMGS_LIST[item?.platform]} alt={item?.platform} style={{ height: '24px', width: '24px' }} />
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography sx={{ color: '#535862', fontWeight: '400', fontSize: '14px' }}>{getFormetedDateWithMonth(item?.created_at)}</Typography>
                </Stack>
              </Stack>
            ))
            }
          </Stack>
        </Box>
      </BootstrapDialog>
    </>
  );
}
